import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

const ReporteTelemetria = lazy(async () => import('./Reporte'))


const Telemetria = ({ match }: any) => {


     return (
          <div className="app-wrapper">
               <Switch>
                    <Suspense fallback={<Loader />}>
                         <Route path={`${match.url}/reporte`} component={ReporteTelemetria} />
                    </Suspense>
               </Switch>
          </div>
     )
}

export default Telemetria
